import React, { useRef, useEffect } from 'react';

function useOutsideAlerter(ref, handleOutsideClick) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        handleOutsideClick();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, handleOutsideClick]);
}
function OutsideAlerter(props) {
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, props.handleOutsideClick);

  return <div ref={wrapperRef}>{props.children}</div>;
}

export default OutsideAlerter;
